import { ForwardedRef, ReactNode } from 'react';
import { HandleSubmitEvent } from './form.types';

interface Props {
  id: string;
  children: ReactNode;
  onSubmit: (submitEvent: HandleSubmitEvent) => void;
  className?: string;
  ref?: ForwardedRef<HTMLFormElement>;
}

export const Form = ({ id, className, children, onSubmit, ref }: Props) => {
  return (
    <form
      id={id}
      ref={ref}
      className={className}
      onSubmit={(formEvent) => {
        formEvent.preventDefault();
        onSubmit(formEvent);
      }}
    >
      {children}
    </form>
  );
};
